export const IsOptimizeEnum = Object.freeze({
    true: 'true',
    false: 'false'
})